<script setup lang="ts">
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import {WidgetProps} from "@/utils/presenters/interfaces.ts";
import {shallowRef} from "vue";
import BigTextFieldWidgetUtil from "@/utils/editView/widgets/BigTextFieldWidgetUtil.ts";
import EditorWidget from "@/components/EditView/editors/EditorWidget.vue";
import Translator from "@/utils/common/Translator.ts";
import type * as monacoEditor from "monaco-editor";

const props = defineProps<WidgetProps>();

const fieldUtil = new BigTextFieldWidgetUtil(props.presenter, props.fieldMetaData);
const xmlEditorRef = shallowRef<monacoEditor.editor.IStandaloneCodeEditor>()

function focus() {
  if (!xmlEditorRef.value)
    return;
  xmlEditorRef.value.focus()
}

function onEditorLoaded(editor: monacoEditor.editor.IStandaloneCodeEditor) {
  xmlEditorRef.value = editor;
  xmlEditorRef.value?.onDidFocusEditorText(fieldUtil.onFocus)
  xmlEditorRef.value?.onDidBlurEditorText(fieldUtil.onBlur)
}

function canReceiveFocus() {
  return !fieldUtil.isFieldDisabled(props.forceEnableField);
}

defineExpose({focus, canReceiveFocus})
</script>
<template>
  <WidgetContainer
    :field="field"
    :entityType="presenter.entityType"
    :isSpanned="isSpanned" :isFieldDisabled="fieldUtil.isFieldDisabled(forceEnableField)"
    :isFieldRequired="fieldUtil.isFieldRequired()" :doNotApplyThemeLayouts="doNotApplyThemeLayouts"
    :isInsideComposite="isInsideComposite">
    <template v-slot:widget>
      <div :dir="Translator.LTR" class="tw-flex tw-flex-col tw-gap-2 tw-max-w-full tw-overflow-hidden">
        <EditorWidget
          :id="field.id"
          fieldSubType="Xml"
          ref="xmlEditorRef" :isFieldDisabled="fieldUtil.isFieldDisabled(forceEnableField)"
          @onEditorLoaded="onEditorLoaded" v-model="fieldUtil.inputFieldValueRef.value"/>
      </div>
    </template>
  </WidgetContainer>
</template>
